<template>
    <div class="order-detail-section mg20">
        <h3>地址信息</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.title}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "express",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    let express = _.head(this.order.content.express);
                    let old_express = _.head(this.order.before_content.finance.express);
                    if(this.$route.query['flow_type'] == this.params.CONTRACT_LINE){
                        old_express = express;
                    }
                    if( express ){
                        express['express_company_memo'] = this.type[express['express_company']-1];
                    }
                    if(old_express ){
                        old_express['express_company_memo'] = this.type[old_express['express_company']-1];
                    }
                    this.test = this.test.map(item => {
                        item.new_content = '无';
                        if(express && typeof express[item.field] != 'undefined'){
                            item.new_content = express[item.field];
                        }else if(old_express){
                            item.new_content = "已删除";
                        }
                        if(old_express && typeof old_express[item.field] != 'undefined'){
                            item.old_content = old_express[item.field];
                        }else{
                            item.old_content = '无';
                        }
                        if(item.new_content != item.old_content){
                            item.new_content = '<span style="color: red">'+item.new_content+'</span>'
                        }
                        return item;
                    });
                }
            }
        },
        data() {
            return {
                type:[
                    '中通快递',
                    '圆通快递',
                    '顺丰快递',
                    '韵达快递',
                    '其他'
                ],
                test:[
                    {
                        field:'name',
                        title:'收件人姓名',
                        new_content:'',
                        old_content:''
                    },
                    {
                        field:'mobile',
                        title:'手机号码',
                        new_content:'',
                        old_content:''
                    },
                    {
                        field:'address',
                        title:'地址',
                        new_content:'',
                        old_content:''
                    },
                    {
                        field:'label_name',
                        title:'地区',
                        new_content:'',
                        old_content:''
                    },
                    {
                        field:'memo',
                        title:'备注',
                        new_content:'',
                        old_content:''
                    },
                    {
                        field:'express_company_memo',
                        title:'快递方式',
                        new_content:'',
                        old_content:''
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/order/finance/express.vue